import { Inputs } from '../../../types';
import { getProjectConfigurationParameters } from './get-project-configuration-parameters';

export const getEditConfigurationBody = (inputsData: Inputs) => {
  const projectConfigurationParameters = getProjectConfigurationParameters(inputsData);
  return {
    projectConfigurationParameters,
  };
};
